import { useEffect } from 'react';

/**
 * NeuronChat Component
 * Injects the Neuron chat widget (neuron.bd) embed script.
 * Note: Login check is handled in App.js — only rendered for logged-in users.
 */
const NEURON_SCRIPT_SRC = 'https://neuron.bd/embed.js';
const NEURON_DATA_KEY = 'wk_kw9mowfld9gzuj1ajsxhcnvf8ykcubby';

const NeuronChat = () => {
    useEffect(() => {
        // Avoid injecting the script more than once (e.g. remounts)
        if (document.querySelector(`script[src="${NEURON_SCRIPT_SRC}"]`)) {
            return;
        }

        const script = document.createElement('script');
        script.src = NEURON_SCRIPT_SRC;
        script.setAttribute('data-key', NEURON_DATA_KEY);
        script.async = true;

        document.getElementsByTagName('head')[0].appendChild(script);
    }, []);

    // This component doesn't render anything visible
    return null;
};

export default NeuronChat;
